import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ExploreMindCardInfo } from '../../interfaces/explore-mind-card-info.interface';

@Component({
    selector: 'mapp-explore-minds-card',
    templateUrl: './explore-minds-card.component.html',
    styleUrls: ['./explore-minds-card.component.scss'],
    standalone: false,
})
export class ExploreMindsCardComponent {
    @Input() exploreMindCardInfo: ExploreMindCardInfo;

    @Output() openModal = new EventEmitter<string>();
}
